export const TELEMETRY_DISTRIBUTED_CLASS = "telemetry.telemetry";
export const COMMAND_DISTRIBUTED_CLASS = "command.command";
export const CHAT_MESSAGE_DISTRIBUTED_CLASS = "chat.message";
export const CHAT_CONVERSATION_DISTRIBUTED_CLASS = "chat.conversation";
export const GEOMARKER_DISTRIBUTED_CLASS = "geomarkers.geomarker";
export const TRANSFER_DISTRIBUTED_CLASS = "transfer.transfer";
export const CUSTOM_DISTRIBUTED_CLASS = "custom.custom";
export const WEATHER_DISTRIBUTED_CLASS = "weather";
export const ADSB_DISTRIBUTED_CLASS = "adsb";